<style lang="stylus">
* {
  scrollbar-width: thin;
  scrollbar-color: #FFC627 #d3d3d3;
}

/* Works on Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 5px;
}

*::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

*::-webkit-scrollbar-thumb {
  background: #FFC627;
}

@media (min-width: 521px) and (max-width: 599px) {
  .gap-left {
    padding-left: 10px !important;
  }
}

@media (min-width: 521px) and (max-width: 532px) {
  .gap-left {
    padding-left: 4px !important;
  }
}

.pronoun-selection {
  .v-select__selection--comma {
    text-transform: capitalize !important;
  }
}

.capitalize {
  text-transform: capitalize !important;
}

/* PlaceAutocompleteElement — styled to match Vuetify outlined text field */
gmp-place-autocomplete {
  display: block;
  width: 100%;
  color-scheme: light;
  --gmp-mat-color-surface: #ffffff;
  --gmp-mat-color-on-surface: rgba(0, 0, 0, 0.87);
  --gmp-mat-color-on-surface-variant: rgba(0, 0, 0, 0.6);
  --gmp-mat-color-primary: #1976d2;
  --gmp-mat-color-outline-decorative: rgba(0, 0, 0, 0.38);
  --gmp-mat-font-family: inherit;
}

gmp-place-autocomplete::part(input-container) {
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 4px;
  height: 56px;
}

gmp-place-autocomplete::part(input) {
  font-size: 1rem;
  font-family: inherit;
  color: rgba(0, 0, 0, 0.87);
  background-color: #ffffff;
}

gmp-place-autocomplete::part(input-container):focus-within {
  border-color: #1976d2;
  border-width: 2px;
}

gmp-place-autocomplete.gmp-input-error::part(input-container) {
  border-color: #b00020;
}

.gmp-field-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 8px;
}

.gmp-field-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  padding-left: 2px;
}

.gmp-field-label--error {
  color: #b00020;
}

.gmp-required {
  color: #b00020;
  margin-left: 2px;
}

.gmp-error-text {
  font-size: 12px;
  color: #b00020;
  padding-left: 16px;
  margin-top: 2px;
}
</style>
<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="540"
    id="edit-profile-modal"
    :content-class="isHidden ? 'hide-scroll' : 'show-scroll'"
  >
    <v-card style="position: relative">
      <!-- Loading Overlay -->
      <v-overlay v-model="activeLoading" class="align-center justify-center" :persistent="true" contained>
        <v-progress-circular color="primary" indeterminate size="48" width="3" />
      </v-overlay>
      <v-card-title
        class="text-h3 px-4 font-weight-black d-flex"
        style="
          background: #ffc627;
          position: sticky;
          top: 0;
          z-index: 999;
          font-weight: 900 !important;
          font-size: 24px !important;
        "
      >
        {{ toggleRequestNameChange ? 'Request name change' : 'Edit profile' }}
        <v-spacer />
        <v-icon
          class="close-icon font-weight-medium align-self-center"
          @click="closeDialog()"
          color="black"
          size="medium"
          >mdi-close</v-icon
        >
      </v-card-title>
      <RequestNameChange
        v-if="toggleRequestNameChange"
        :formModel="formModel"
        @toggleRequestNameChangeAndEditProfile="toggleRequestNameChangeAndEditProfile"
      />
      <v-form v-else ref="form" v-model="valid">
        <v-container class="container">
          <v-row wrap>
            <v-col
              cols="12"
              class="text-h3 font-weight-black"
              style="font-weight: 900 !important; font-size: 24px !important"
            >
              Basic Information
            </v-col>
          </v-row>
          <v-row wrap>
            <v-col cols="12" class="mt-2">
              <v-col cols="12" class="subheading font-weight-black mb-2">Primary Name</v-col>
              <v-row wrap>
                <v-col>
                  <v-row wrap class="mb-2">
                    <v-col>
                      <v-text-field
                        label="First Name"
                        id="primaryFirstName"
                        class="text-box-mr"
                        v-model="formModel.firstName"
                        @change="
                          asuoDataLayerClick('signup', '1', {
                            text: formModel.firstName
                          });
                          onPasteCheckLanguageforFirstname($event);
                        "
                        :rules="nameRules"
                        @keydown="
                          checkLanguage($event);
                          changeTextToSentenseCase(formModel);
                        "
                        required
                        hide-details
                        placeholder
                        variant="outlined"
                        disabled
                        style="margin-right: 8px"
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="Last Name"
                        :class="[{ 'mt-0': $vuetify.display.xs }]"
                        class="gap-left"
                        id="primaryLastName"
                        v-model="formModel.lastName"
                        @change="
                          asuoDataLayerClick('signup', '1', {
                            text: formModel.lastName
                          });
                          onPasteCheckLanguageforFirstname($event);
                        "
                        :rules="nameRules"
                        @keydown="
                          checkLanguage($event);
                          changeTextToSentenseCase(formModel);
                        "
                        required
                        hide-details
                        placeholder
                        variant="outlined"
                        disabled
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row wrap>
            <v-col cols="12" class="mt-2">
              <v-col cols="12" class="subheading font-weight-black mb-2">Preferred Name</v-col>
              <v-row wrap>
                <v-col>
                  <v-row wrap class="mb-6">
                    <v-col>
                      <v-text-field
                        label="First Name"
                        id="preferredFirstName"
                        class="text-box-mr"
                        v-model="formModel.preferredFirstName"
                        @change="
                          asuoDataLayerClick('editProfileModal', '4', {
                            text: formModel.preferredFirstName
                          });
                          onPasteCheckLanguageforFirstname($event);
                        "
                        :rules="nameRules"
                        @keydown="
                          checkLanguage($event);
                          changeTextToSentenseCase(formModel);
                        "
                        required
                        hide-details
                        placeholder
                        variant="outlined"
                        style="margin-right: 8px"
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="Last Name"
                        :class="[{ 'mt-0': $vuetify.display.xs }]"
                        class="gap-left"
                        id="preferredLastName"
                        v-model="formModel.preferedLastName"
                        @change="
                          asuoDataLayerClick('signup', '1', {
                            text: formModel.preferedLastName
                          });
                          onPasteCheckLanguageforFirstname($event);
                        "
                        :rules="nameRules"
                        @keydown="
                          checkLanguage($event);
                          changeTextToSentenseCase(formModel);
                        "
                        required
                        placeholder
                        hide-details
                        variant="outlined"
                        disabled
                        style="margin-bottom: -28px"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row wrap>
            <v-col class="my-2 mb-8 caption">
              <a style="text-decoration: underline; color: #8c1d40; font-size: 12px" @click="showRequestNameChange">
                Request name change</a
              >
            </v-col>
          </v-row>
          <v-row wrap>
            <v-col cols="12">
              <v-col cols="12" class="subheading font-weight-black mb-2">Primary Email</v-col>
              <v-row wrap>
                <v-col>
                  <v-text-field
                    ref="primaryEmailInput"
                    type="email"
                    id="E-mail"
                    label="Primary Email"
                    v-model="formModel.email"
                    @change="
                      asuoDataLayerClick('signup', '3', {
                        text: formModel.email
                      });
                      onPasteCheckLanguageforEmail($event);
                    "
                    @keydown="
                      checkEmailLanguage($event);
                      clearPrimaryEmailError();
                    "
                    required
                    placeholder
                    variant="outlined"
                    :rules="[(v) => emailValidation(v), () => primaryErrorEmail || true]"
                    :error-messages="[primaryErrorEmail].filter(Boolean)"
                    style="margin-bottom: -18px"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row wrap>
            <v-col cols="12">
              <v-row wrap>
                <v-col cols="12" class="mt-4">
                  <v-checkbox
                    v-model="showNotificationEmail"
                    label="Same as primary email"
                    class="mt-2"
                    color="black"
                    @change="toggleNotificationEmail"
                  />
                </v-col>

                <v-col cols="12" class="subheading font-weight-black mb-2" v-if="!showNotificationEmail"
                  >Notifications Email</v-col
                >
                <v-text-field
                  type="email"
                  id="Email"
                  v-if="!showNotificationEmail"
                  label="Notifications Email"
                  v-model="formModel.notificationsEmail"
                  @change="
                    asuoDataLayerClick('signup', '1', {
                      text: formModel.notificationsEmail
                    });
                    onPasteCheckLanguageforEmail($event);
                  "
                  @keydown="checkEmailLanguage($event)"
                  required
                  placeholder
                  variant="outlined"
                  :rules="[(v) => emailValidation(v)]"
                  style=""
                />
              </v-row>
            </v-col>
          </v-row>
          <v-row wrap>
            <v-col cols="12" class="mt-2">
              <v-row wrap>
                <v-col cols="12" class="subheading font-weight-black">Birthday</v-col>
                <v-col>
                  <v-row wrap>
                    <v-col xl="4" md="4" sm="4" cols="12" class="px-0">
                      <v-select
                        class="text-box-mr"
                        :items="months"
                        required
                        @change="
                          asuoDataLayerClick('signup', '4', {
                            text: dob.birth_month
                          })
                        "
                        v-model="dob.birth_month"
                        variant="outlined"
                        hide-details
                        label="Month"
                        v-on:change="updateDOB()"
                        :rules="[(v) => !!v || 'This is required']"
                        disabled
                      />
                    </v-col>
                    <v-col md="4" xl="4" sm="4" cols="12" class="p2">
                      <v-select
                        :items="days"
                        class="text-box-mr text-box-ml"
                        required
                        v-model="dob.birth_day"
                        @change="
                          asuoDataLayerClick('signup', '5', {
                            text: dob.birth_day
                          })
                        "
                        variant="outlined"
                        hide-details
                        label="Day"
                        v-on:change="updateDOB()"
                        :rules="[(v) => !!v || 'This is required']"
                        disabled
                      />
                    </v-col>
                    <v-col xl="4" md="4" sm="4" cols="12" class="px-0">
                      <v-autocomplete
                        class="text-box-ml"
                        :items="years"
                        required
                        v-model="dob.birth_year"
                        variant="outlined"
                        hide-details
                        @change="
                          asuoDataLayerClick('signup', '6', {
                            text: dob.birth_year
                          })
                        "
                        label="Year"
                        v-on:change="updateDOB()"
                        :rules="[(v) => validateAge()]"
                        disabled
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row wrap>
            <v-col cols="12" class="mt-2">
              <v-row wrap>
                <v-col cols="12" class="subheading font-weight-black mb-2">Address</v-col>
                <v-col>
                  <v-row wrap>
                    <v-col cols="12" class="p2">
                      <div class="gmp-field-wrapper">
                        <label class="gmp-field-label" :class="{ 'gmp-field-label--error': fields.address.error }">
                          Address line 1<span class="gmp-required">*</span>
                        </label>
                        <street-address-field
                          ref="streetField"
                          v-model:street="formModel.mailingAddress.street"
                          v-model:place="formModel.place"
                          :places-ready="placesReady"
                          :places-failed="placesFailed"
                          :error="!!fields.address.error"
                          @manual-input="addressCheck"
                        />
                        <div v-if="fields.address.error" class="gmp-error-text">{{ fields.address.error }}</div>
                      </div>
                    </v-col>
                    <v-col cols="12" class="userInfoLabel mt-3 mb-1" style="font-size: 12px">
                      <span>&nbsp;PO Box Addresses are not accepted</span>
                    </v-col>
                    <v-col lg="4" md="4" sm="4" cols="12" class="px-0 mb-4">
                      <v-text-field
                        label="City"
                        @change="
                          asuoDataLayerClick('editProfileModal', '9', {
                            text: formModel.mailingAddress.city
                          })
                        "
                        class="text-box-mr"
                        v-model="formModel.mailingAddress.city"
                        placeholder
                        hide-details
                        variant="outlined"
                        :rules="[(v) => !!v || 'This is required']"
                      />
                    </v-col>
                    <v-col lg="4" md="4" sm="4" cols="12" class="p2">
                      <v-autocomplete
                        label="Country"
                        v-model="selectedCountryCode"
                        :items="countryOptions"
                        item-value="value"
                        item-title="title"
                        hide-details
                        variant="outlined"
                        :rules="[(v) => !!v || 'This is required']"
                        :loading="countriesLoading"
                        :disabled="countriesLoading"
                        @update:model-value="onCountryChange"
                      />
                    </v-col>
                    <v-col lg="4" md="4" sm="4" cols="12" class="p2 ml-0 pl-0">
                      <v-autocomplete
                        label="State"
                        v-model="formModel.mailingAddress.state"
                        :items="stateOptions"
                        item-value="value"
                        item-title="title"
                        hide-details
                        variant="outlined"
                        :disabled="countriesLoading || !stateOptions.length"
                        :loading="countriesLoading"
                        :rules="[(v) => !!v || 'This is required']"
                        @update:model-value="asuoDataLayerClick('editProfileModal', '10', { text: $event })"
                      />
                    </v-col>
                    <v-col lg="4" md="4" sm="4" cols="12" class="px-0">
                      <v-text-field
                        label="Zip Code"
                        @change="
                          asuoDataLayerClick('editProfileModal', '11', {
                            text: formModel.mailingAddress.zipCode
                          })
                        "
                        v-model="formModel.mailingAddress.zipCode"
                        placeholder
                        hide-details
                        variant="outlined"
                        :rules="[(v) => zipcodeCheck()]"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row wrap>
            <v-col cols="12">
              <v-row wrap>
                <v-col cols="12" class="subheading font-weight-black">Phone</v-col>
                <v-col>
                  <vue-tel-input
                    v-model="formModel.phoneNumber"
                    style="height: 56px"
                    @blur="
                      phoneFieldTouched = true;
                      asuoDataLayerClick('editProfileModal', '13', {
                        text: formModel.phoneNumber
                      });
                    "
                    @validate="handlePhoneValidation"
                    @on-input="handlePhoneInput"
                    @focus="phoneFieldTouched = true"
                    :preferredCountries="['us', 'gb']"
                    :defaultCountry="'us'"
                    :validCharactersOnly="true"
                    :autoDefaultCountry="false"
                  />

                  <!-- Custom validation display -->
                  <div
                    v-if="fields.phoneNumber.error"
                    class="v-messages theme--light error--text"
                    style="margin-top: 4px"
                  >
                    <div class="v-messages__wrapper">
                      <div class="v-messages__message" style="padding: 0px; font-size: 12px; color: #d32f2f">
                        {{ fields.phoneNumber.error }}
                      </div>
                    </div>
                  </div>

                  <!-- Required field validation -->
                  <div
                    v-if="!formModel.phoneNumber && phoneFieldTouched"
                    class="v-messages theme--light error--text"
                    style="margin-top: 4px"
                  >
                    <div class="v-messages__wrapper">
                      <div class="v-messages__message" style="padding: 0px; font-size: 12px; color: #d32f2f">
                        Phone number is required
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row wrap v-if="collectDemographicInfo">
            <v-col cols="12">
              <v-divider class="mb-3" />
            </v-col>
          </v-row>
          <v-row wrap v-if="collectDemographicInfo">
            <v-col
              cols="12"
              class="text-h3 font-weight-black"
              style="font-weight: 900 !important; font-size: 24px !important"
            >
              Demographic Information
            </v-col>
            <v-col cols="12" class="mt-2">
              <v-row wrap>
                <v-col cols="12" sm="6" class="px-0 pr-1">
                  <div @click="(e) => disableEnableScroll('hideScroll', e, 'gender')">
                    <v-autocomplete
                      :items="genderValues"
                      class="text-box-mr"
                      @change="
                        asuoDataLayerClick('UserInfo', '22', {
                          text: formModel.gender,
                          type: 'gender',
                          section: 'demographic information'
                        });
                        clearOtherGender();
                        disableEnableScroll('showScroll', null, 'gender');
                      "
                      v-model="formModel.gender"
                      :rules="[(v) => !!v || 'This is required']"
                      hide-details
                      variant="outlined"
                      label="Gender"
                    />
                  </div>
                </v-col>

                <v-col cols="12" sm="6" class="px-0 pl-1 mb-2">
                  <div @click="(e) => disableEnableScroll('hideScroll', e, 'pronoun')">
                    <v-autocomplete
                      :class="otherPronouns.indexOf(formModel.pronoun) < 0 ? 'pronoun-selection' : ''"
                      :items="pronounsValues"
                      @change="
                        asuoDataLayerClick('UserInfo', '22', {
                          text: formModel.pronoun,
                          type: 'pronouns',
                          section: 'demographic information'
                        });
                        checkOtherPronoun();
                        disableEnableScroll('showScroll', null, 'pronoun');
                      "
                      v-model="formModel.pronoun"
                      :rules="[(v) => !!v || 'This is required']"
                      hide-details
                      variant="outlined"
                      label="Pronouns"
                    />
                  </div>
                </v-col>
                <v-col cols="12" sm="6" v-if="genderOptionCheck" class="mb-4 pr-3">
                  <v-text-field
                    label="I self-identify as"
                    v-model="learnerInfoOtherOption.genderOther"
                    style="margin-bottom: -28px"
                    required
                    variant="outlined"
                    :rules="[(v) => !!v || 'Your Gender is required']"
                  />
                </v-col>
                <!-- For other pronouns options but not required now -->
                <v-col cols="12" v-if="false" class="mb-4">
                  <v-text-field
                    label="Add another pronoun"
                    v-model="learnerInfoOtherOption.pronounOther"
                    style="margin-bottom: -28px"
                    required
                    variant="outlined"
                    :rules="[(v) => !!v || 'The Pronoun is required']"
                  />
                </v-col>

                <v-col cols="12" class="mb-4">
                  <div @click="(e) => disableEnableScroll('hideScroll', e, 'ethnicity')">
                    <v-autocomplete
                      :items="ethnicityValues"
                      @change="
                        asuoDataLayerClick('UserInfo', '22', {
                          text: formModel.ethnicity,
                          type: 'ethnicity',
                          section: 'demographic information'
                        });
                        disableEnableScroll('showScroll', null, 'ethnicity');
                      "
                      v-model="formModel.ethnicity"
                      :rules="[(v) => v.length > 0 || 'This is required']"
                      variant="outlined"
                      label="Ethnicity"
                      multiple
                      chips
                      :menu-props="{
                        maxHeight: 190,
                        closeOnContentClick: true
                      }"
                    />
                  </div>
                </v-col>
                <!-- For other ethnicity options but not required now -->
                <v-col cols="12" v-if="false" class="mb-4">
                  <v-text-field
                    label="Other"
                    v-model="learnerInfoOtherOption.ethnicityOther"
                    style="margin-bottom: -28px"
                    required
                    variant="outlined"
                    :rules="[(v) => !!v || 'Your Ethnicity is required']"
                  />
                </v-col>
                <v-col cols="12" class="mb-4">
                  <div @click="(e) => disableEnableScroll('hideScroll', e, 'householdIncome')">
                    <v-autocomplete
                      :items="householdIncomeValues"
                      @change="
                        asuoDataLayerClick('UserInfo', '22', {
                          text: formModel.householdIncome,
                          type: 'household income',
                          section: 'demographic information'
                        });
                        disableEnableScroll('showScroll', null, 'householdIncome');
                      "
                      v-model="formModel.householdIncome"
                      :rules="[(v) => !!v || 'This is required']"
                      variant="outlined"
                      label="Household Income"
                      class="custom-color-code"
                      :menu-props="{ maxHeight: 190 }"
                    />
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-col cols="12" class="subheading font-weight-black mb-2">Which best describes you?</v-col>
                  <v-row wrap>
                    <v-col>
                      <div @click="(e) => disableEnableScroll('hideScroll', e, 'learnersIntent')">
                        <v-autocomplete
                          :items="learnersIntentsList"
                          @change="
                            asuoDataLayerClick('UserInfo', '22', {
                              text: formModel.learnersIntent,
                              type: 'which best describes you?',
                              section: 'demographic information'
                            });
                            disableEnableScroll('showScroll', null, 'learnersIntent');
                          "
                          v-model="formModel.learnersIntent"
                          :rules="[(v) => !!v || 'This is required']"
                          variant="outlined"
                          label="I am..."
                          :menu-props="{ maxHeight: 190 }"
                        />
                      </div>
                    </v-col>
                    <v-col v-if="learnersIntentOptionCheck" class="mb-4">
                      <v-text-field
                        label="Other"
                        v-model="learnerInfoOtherOption.learnersIntentOther"
                        style="margin-bottom: -28px"
                        required
                        variant="outlined"
                        :rules="[(v) => !!v || 'Your Intent is required']"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- TODO: Update Education Information -->
          <v-col v-if="showEducationalInfo">
            <v-divider class="my-3" />
          </v-col>
          <v-row wrap v-if="showEducationalInfo">
            <v-col cols="12" class="headline font-weight-black">Educational Information</v-col>
            <v-col cols="12" class="mt-2">
              <v-row wrap>
                <v-col>
                  <v-text-field
                    label="High School"
                    @change="
                      asuoDataLayerClick('editProfileModal', '14', {
                        text: formModel.currentHighSchool
                      })
                    "
                    v-model="formModel.currentHighSchool"
                    variant="outlined"
                    class="mb-2"
                  />
                </v-col>
              </v-row>
              <v-row wrap>
                <v-col cols="12">
                  <div class="mb-2">
                    <label class="font-weight-bold">Expected Graduate Date</label>
                  </div>
                  <v-row wrap>
                    <!-- Month Selector -->
                    <v-col cols="6">
                      <v-select
                        :rules="[(v) => !!v || 'Graduation Month is required']"
                        label="Month"
                        :modelValue="formModel.highSchoolExpectedGraduationMonth"
                        @update:modelValue="updateGraduationMonth"
                        :items="months"
                        variant="outlined"
                        class="text-box-mr mb-2"
                      />
                    </v-col>
                    <!-- Year Selector -->
                    <v-col cols="6">
                      <v-select
                        :rules="[(v) => !!v || 'Graduation Year is required']"
                        label="Year"
                        :modelValue="formModel.highSchoolExpectedGraduationYear"
                        @update:modelValue="updateGraduationYear"
                        :items="graduationYear"
                        variant="outlined"
                        class="mb-2"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-col :class="collectDemographicInfo ? 'mb-2 mt-4' : 'mt-4 mb-3'">
            <v-btn
              @click="saveUsersInfo"
              rounded
              variant="flat"
              class="font-weight-black ml-0"
              style="background-color: #fec528"
              :disabled="!checkIfFormUpdated"
            >
              <span class="px-3"> Save </span>
            </v-btn>
          </v-col>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
/* global google */
import { defineComponent, nextTick } from 'vue';
import { useUserStore } from '@/stores/user';
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import { Helper } from '../mixins/helpers.js';
import { DataLayerMixin } from '../mixins/dataLayerMixin.js';
import { AjaxLoader } from '../mixins/ajaxLoader';
import RequestNameChange from './RequestNameChange.vue';
import StreetAddressField from './StreetAddressField.vue';
import { Logger } from '../mixins/logger';
import moment from 'moment-timezone';
import { useCountryData } from '@/composables/useCountryData';
import { importLibrary } from '@/utils/mapsLoader';
import { MIN_LEARNER_AGE, ageInYears } from '@/utils/dateUtils';

export default defineComponent({
  emits: ['closeModal', 'editProfile', 'update:modelValue'],
  name: 'EditProfileModal',

  components: {
    VueTelInput,
    RequestNameChange,
    StreetAddressField
  },

  setup() {
    const {
      countries,
      loading: countriesLoading,
      fetchCountryData,
      countryOptions,
      getStateOptions
    } = useCountryData();

    return {
      countries,
      countriesLoading,
      fetchCountryData,
      countryOptions,
      getStateOptions
    };
  },

  data() {
    return {
      placesReady: false,
      placesFailed: false,
      toggleRequestNameChange: false,
      originalForm: null,
      originalLearnerInfoOtherOption: null,
      originalMailingAddress: null,
      dialog: false,
      valid: true,
      prevFormModelName: '',
      formModel: {
        mailingAddress: {},
        ethnicity: []
        // pronouns: []
      },
      learnerInfoOtherOption: {
        pronounOther: '',
        genderOther: '',
        ethnicityOther: '',
        learnersIntentOther: ''
      },
      currentHighSchool: '',
      expectedGraduateDate: '',
      highSchoolExpectedGraduationMonth: '',
      highSchoolExpectedGraduationYear: '',
      educationInfo: {},
      pronounsValues: ['he/him', 'she/her', 'they/them', 'it/its', 'Prefer not to say'],
      genderValues: ['Male', 'Female', 'Nonbinary', 'Prefer not to say', 'I self-identify as'],
      learnersIntentsList: [
        'I’m an Earned Admission learner, taking courses to earn my admission to ASU',
        'I’m a high school learner',
        'I’m a homeschool learner',
        'I’m visiting student, currently attending another institution (university or college)',
        'I’m learning for fun, with no intention of getting credit',
        'Other'
      ],
      ethnicityValues: [
        'Asian',
        'Black or African-American',
        'White',
        'Hispanic/Latino',
        'American Indian or Alaska Native',
        'Native Hawaiian or Pacific Islander',
        'Prefer not to say'
      ],
      householdIncomeValues: [
        'Under $15,000',
        '$15,000-$24,999',
        '$25,000-$34,999',
        '$35,000-$49,999',
        '$50,000-$74,999',
        '$75,000-$99,999',
        '$100,000-$149,999',
        '$150,000-$199,999',
        'Over $200,000',
        'Don’t know',
        'Prefer not to say'
      ],
      years: [],
      days: '1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31'.split(' '),
      months: 'January February March April May June July August September October November December'.split(' '),
      dob: {
        birth_day: '',
        birth_month: '',
        birth_year: ''
      },
      fields: {
        phoneNumber: {
          error: ''
        },
        address: { error: '' },
        googleAddress: {
          listAvailable: false,
          listSelected: false
        }
      },
      nameRules: [
        (v) => !!v || 'This is required',
        (v) => (v || '').length < 24 || 'Name must be less than 24 characters'
      ],
      otherPronouns: ['Prefer not to say'],
      isHidden: false,
      showNotificationEmail: false,
      primaryErrorEmail: null,
      phoneFieldTouched: false,
      selectedCountryCode: 'USA',
      stateOptions: []
    };
  },

  mixins: [Helper, DataLayerMixin, AjaxLoader, Logger],

  props: {
    learnerData: Object,
    collectDemographicInfo: Boolean,
    modelValue: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    userStore() {
      return useUserStore();
    },
    checkIfFormUpdated() {
      return (
        Object.keys(this.formModel).filter((e) => this.formModel[e] !== this.originalForm[e]).length > 0 ||
        Object.keys(this.learnerInfoOtherOption).filter(
          (e) => this.learnerInfoOtherOption[e] !== this.originalLearnerInfoOtherOption[e]
        ).length > 0 ||
        Object.keys(this.formModel.mailingAddress).filter(
          (e) => this.formModel.mailingAddress[e] !== this.originalMailingAddress[e]
        ).length > 0 ||
        (this.formModel.notificationsEmail !== this.formModel.email && this.showNotificationEmail)
      );
    },

    learnersIntentOptionCheck() {
      return this.formModel.learnersIntent === this.learnersIntentsList[this.learnersIntentsList.length - 1];
    },
    genderOptionCheck() {
      return this.formModel.gender === this.genderValues[this.genderValues.length - 1];
    },
    ethnicityOptionCheck() {
      return this.formModel.ethnicity === this.ethnicityValues[this.ethnicityValues.length - 1];
    },
    pronounOptionCheck() {
      return this.formModel.pronoun.indexOf('Add another pronoun') > -1;
    },
    tempPronoun() {
      return this.formModel.pronoun.filter((e) => e !== 'Add another pronoun');
    },
    graduationYear() {
      const currentYear = new Date().getFullYear();
      const range = 6; // Only future years (adjust as needed)
      const futureYears = Array.from({ length: range }, (_, i) => currentYear + i);

      const selectedYear = this.formModel.highSchoolExpectedGraduationYear;

      // Add previously selected year if it's not already in the futureYears array.
      if (selectedYear && !futureYears.includes(selectedYear)) {
        futureYears.unshift(selectedYear);
      }

      return futureYears;
    },
    showEducationalInfo() {
      return Helper.methods.isAcceleratePartner(this.userStore.apis.learnerData._partnerURLSubDomain);
    }
  },

  watch: {
    modelValue: {
      immediate: true,
      handler(newVal) {
        this.dialog = newVal;
      }
    },
    dialog(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.initializeAutocomplete();
        });
      }
    }
  },

  methods: {
    clearPrimaryEmailError() {
      this.primaryErrorEmail = '';
    },

    onCountryChange(countryCode) {
      this.stateOptions = this.getStateOptions(countryCode);
      const country = this.countries.find((c) => c.countryCode === countryCode);
      if (country) {
        this.formModel.mailingAddress.country = country.description;
        this.asuoDataLayerClick('editProfileModal', '12', { text: country.description });
      }
      // Clear state if it doesn't exist in new country
      if (this.formModel.mailingAddress.state) {
        const stateExists = this.stateOptions.some((s) => s.value === this.formModel.mailingAddress.state);
        if (!stateExists) {
          this.formModel.mailingAddress.state = '';
        }
      }
    },

    addressCheck() {
      if (!this.formModel.place) {
        this.fields.address.error = 'This field is required';
      } else {
        this.fields.address.error = '';
      }
    },

    enterkeyprevent() {
      var el = document.getElementById('enterKeyPrevent');
      if (el) {
        el.addEventListener('keypress', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
          }
        });
      }
    },

    checkLanguageforAddress() {
      // Language check for address input - kept for compatibility
    },

    async initializeAutocomplete() {
      if (this._gmpListenerAdded) return;

      try {
        await importLibrary('places');
        this.placesReady = true;
      } catch (err) {
        console.warn('[EditProfileModal] Failed to load Google Places API:', err);
        this.placesFailed = true;
        return;
      }

      await this.$nextTick();

      const el = this.$refs.streetField?.getAutocompleteEl();
      if (!el) return;

      this._gmpListenerAdded = true;

      el.addEventListener('gmp-select', async (event) => {
        const placePrediction = event.placePrediction;
        if (!placePrediction) return;

        try {
          const place = placePrediction.toPlace();
          await place.fetchFields({ fields: ['addressComponents', 'formattedAddress', 'displayName'] });

          if (place.addressComponents?.length) {
            this.fields.googleAddress.listSelected = true;
            this.fields.googleAddress.listAvailable = true;
            this.formModel.place = place.formattedAddress || place.displayName?.text || '';
            this.formModel.mailingAddress = this.getMailingAddress(place);
            el.value = this.formModel.mailingAddress.street || '';
            this.fields.address.error = '';
          } else {
            this.fields.googleAddress.listSelected = false;
            this.fields.googleAddress.listAvailable = false;
          }
        } catch (err) {
          console.warn('[EditProfileModal] fetchFields failed:', err);
        }
      });

      el.addEventListener('input', () => {
        this.formModel.place = el.value || '';
      });
    },
    scrollToEmailInput() {
      nextTick(() => {
        const emailInput = this.$refs.primaryEmailInput.$el;
        const errorMessage = emailInput.querySelector('.v-messages__message');
        if (errorMessage) {
          errorMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    },
    disableEnableScroll(scrollStatus, e, formModelName) {
      if (e) {
        e.stopPropagation();
      }
      if (scrollStatus == 'showScroll') {
        this.isHidden = false;
      }
      if (scrollStatus == 'hideScroll') {
        this.isHidden = true;
      }
      if (
        e &&
        (e.target.classList.contains('v-text-field__details') ||
          e.target.classList.contains('v-messages__message') ||
          e.target.classList.contains('v-messages')) &&
        this.prevFormModelName !== formModelName
      ) {
        this.isHidden = false;
      }
      this.prevFormModelName = formModelName;
    },
    clearOtherGender() {
      this.learnerInfoOtherOption.genderOther = '';
    },

    closeDialog() {
      this.dialog = false;
      this.$emit('update:modelValue', false);
      this.$emit('closeModal');
      this.toggleRequestNameChange
        ? this.asuoDataLayerClick('editProfileModal', '0', {
            section: 'request name change'
          })
        : this.asuoDataLayerClick('editProfileModal', '0');
    },
    editProfile() {
      this.$emit('editProfile');
    },

    checkOtherPronoun() {
      if (this.formModel.pronoun.indexOf('Add another pronoun') < 0) {
        this.learnerInfoOtherOption.pronounOther = '';
      }
    },

    toggleRequestNameChangeAndEditProfile() {
      if (this.toggleRequestNameChange) {
        this.showRequestNameChange();
      } else {
        this.editProfile();
      }
    },

    showRequestNameChange() {
      if (!this.toggleRequestNameChange) {
        this.asuoDataLayerClick('editProfileModal', '3');
      }
      this.toggleRequestNameChange = !this.toggleRequestNameChange;
    },

    // updatePronoun(event) {
    //   this.learnerInfoOtherOption.pronounOther = this.tempPronoun;
    // },

    emailValidation(email) {
      if (!email) {
        return 'Email is required';
        // eslint-disable-next-line no-useless-escape
      } else if (!/.+@.+/.test(email) || !/^\w+([\.-]?\w+)\@\w+([\.-]?\w+)(\.\w{2,3})+$/.test(email)) {
        return 'Email must be valid';
      } else {
        return true;
      }
    },

    async saveUsersInfo() {
      const updatedObject = { mailingAddress: {} };

      if (this.showNotificationEmail) {
        this.formModel.notificationsEmail = this.formModel.email;
      }

      if (this.formModel.highSchoolExpectedGraduationMonth && this.formModel.highSchoolExpectedGraduationYear) {
        const formattedHighSchoolGraduationDate = moment(
          `${this.formModel.highSchoolExpectedGraduationYear}-${this.formModel.highSchoolExpectedGraduationMonth}-01`,
          'YYYY-MMMM-DD'
        ).format('YYYY-MM-DD');
        this.formModel.highSchoolExpectedGraduationDate = formattedHighSchoolGraduationDate;
      }

      const updatedInfosObject = Object.keys(this.formModel).filter((e) => this.formModel[e] !== this.originalForm[e]);
      const otherUpdatedInfosObject = Object.keys(this.learnerInfoOtherOption).filter(
        (e) => this.learnerInfoOtherOption[e] !== this.originalLearnerInfoOtherOption[e]
      );
      const updatedMailingAddressObject = Object.keys(this.formModel.mailingAddress).filter(
        (e) => (this.formModel || {}).mailingAddress[e] !== this.originalMailingAddress[e]
      );

      updatedInfosObject.map(
        (e) => (updatedObject[e] = e === 'ethnicity' ? this.formModel[e].join(';') : this.formModel[e])
      );
      otherUpdatedInfosObject.map((e) => (updatedObject[e] = this.learnerInfoOtherOption[e]));
      updatedMailingAddressObject.map(
        (e) => ((updatedObject.mailingAddress || {})[e] = (this.formModel.mailingAddress || {})[e])
      );

      if ((updatedObject.ethnicity || '').includes('Prefer not to say')) updatedObject.ethnicity = 'Prefer not to say';
      if ((this.formModel.ethnicity || []).includes('Prefer not to say'))
        this.formModel.ethnicity = ['Prefer not to say'];
      if (
        this.$refs.form.validate() &&
        this.formModel.phoneNumber &&
        this.formModel.place &&
        !this.fields.phoneNumber.error &&
        Object.keys(updatedObject).length > 0
      ) {
        // to pronoun filter other pronouns options
        // if (updatedObject.pronoun) {
        //   if (updatedObject.pronoun.indexOf('Add another pronoun') > -1) {
        //     updatedObject.pronoun = updatedObject.pronoun.filter((pronoun) => pronoun !== 'Add another pronoun');
        //     if (updatedObject.pronounOther) {
        //       updatedObject.pronoun.push(updatedObject.pronounOther);
        //       updatedObject.pronoun = updatedObject.pronoun.join();
        //       delete updatedObject.pronounOther;
        //     } else {
        //       updatedObject.pronoun = updatedObject.pronoun.join();
        //     }
        //   } else {
        //     updatedObject.pronoun = updatedObject.pronoun.join();
        //   }
        // }

        this.asuoDataLayerClick('editProfileModal', '1', {
          first_name: this.formModel.firstName,
          last_name: this.formModel.lastName,
          email: this.formModel.email,
          phone: this.formModel.phoneNumber
        });
        let self = this;
        await this.$conn
          .patchLearnerContactInfo(updatedObject)
          .then(async function (res) {
            self.logInfo('patchLearnerInfo', res.data.message);

            if (res.data.message === 'This email is already in use. You must use a unique email.') {
              self.primaryErrorEmail = res.data.message;
              self.scrollToEmailInput();
            } else self.$router.go();
          })
          .catch((err) => {
            self.logError('patchLearnerInfo', err);
          });
      } else {
        nextTick(() => {
          const el = document.querySelector('.v-messages__message:nth-child(1)');

          if (el) {
            if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
              this.scrollElementIntoView(el, 'smooth');
            } else {
              el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
        });
      }
    },
    scrollElementIntoView(element, behavior) {
      let scrollTop = window.pageYOffset || element.scrollTop;

      // Furthermore, if you have for example a header outside the iframe
      // you need to factor in its dimensions when calculating the position to scroll to
      const headerOutsideIframe = window.parent.document.getElementsByClassName('myHeader')[0].clientHeight;

      const finalOffset = element.getBoundingClientRect().top + scrollTop + headerOutsideIframe;

      window.parent.scrollTo({
        top: finalOffset,
        behavior: behavior || 'auto'
      });
    },

    // pronounToTitleCase(str) {
    //   let pronounToTitleCase = (str || '').split('/').map((e) =>
    //     e.replace(/\w\S*/g, function (txt) {
    //       return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    //     })
    //   );
    //   return pronounToTitleCase.join('/') || null;
    // },

    assignLearnerInfo() {
      this.formModel = {
        ...this.learnerData,
        pronoun: this.learnerData.pronoun,
        ethnicity: (this.learnerData.ethnicity || '').includes(';')
          ? (this.learnerData.ethnicity || '').split(';')
          : (this.learnerData.ethnicity || '').length > 0
            ? this.learnerData.ethnicity.split()
            : []
      };
      this.formModel.place = this.learnerData.mailingAddress.street;
      this.formModel.mailingAddress.zipCode = this.learnerData.mailingAddress.postalCode;
      this.dob = { ...this.getDateOfBirth(this.formModel) };
      if (this.checkForOtherDropdownOptions('learnersIntent')) {
        this.learnerInfoOtherOption.learnersIntentOther = this.formModel.learnersIntent;
        this.formModel.learnersIntent = 'Other';
      }

      if (this.checkForOtherDropdownOptions('gender')) {
        this.learnerInfoOtherOption.genderOther = this.formModel.gender;
        this.formModel.gender = 'I self-identify as';
      }
      this.formModel.currentHighSchool = this.learnerData.currentHighSchool;

      const graduationDate = moment(this.learnerData.highSchoolExpectedGraduationDate); // Parse the date

      if (this.learnerData.highSchoolExpectedGraduationDate) {
        this.formModel.highSchoolExpectedGraduationMonth = graduationDate.format('MMMM'); // Extract month
        this.formModel.highSchoolExpectedGraduationYear = parseInt(graduationDate.format('YYYY'), 10); // Extract year
      } else {
        this.formModel.highSchoolExpectedGraduationMonth = '';
        this.formModel.highSchoolExpectedGraduationYear = '';
      }

      // For other ethnicity options but not required now
      // if (this.checkForOtherDropdownOptions('ethnicity')) {
      //   this.learnerInfoOtherOption.ethnicityOther = this.formModel.ethnicity;
      //   this.formModel.ethnicity = 'Other';
      // }

      // For other pronoun options but not required now
      // if (this.checkForOtherDropdownOptions('pronoun')) {
      //   this.learnerInfoOtherOption.pronounOther = this.formModel.pronoun.filter((pronoun) => this.pronounsValues.indexOf(pronoun) === -1);
      // }

      this.originalForm = Object.assign({}, this.formModel);
      this.originalLearnerInfoOtherOption = Object.assign({}, this.learnerInfoOtherOption);
      this.originalMailingAddress = Object.assign({}, this.formModel.mailingAddress);
    },

    checkForOtherDropdownOptions(from) {
      from = (from || '').toLowerCase();

      switch (from) {
        case 'gender':
          return this.formModel.gender && this.genderValues.indexOf(this.formModel.gender) < 0;
        case 'learnersintent':
          return this.formModel.learnersIntent && this.learnersIntentsList.indexOf(this.formModel.learnersIntent) < 0;
        case 'ethnicity':
          return this.formModel.ethnicity && this.ethnicityValues.indexOf(this.formModel.ethnicity) < 0;
        case 'pronoun':
          return this.formModel.pronoun && this.pronounsValues.indexOf(this.formModel.pronoun) < 0;

        default:
          break;
      }
    },

    getDateOfBirth({ birthDate }) {
      const date = new Date(birthDate);
      return {
        // birth_day inside tilde because the text field accepts a string. Can be changed in the future
        birth_day: `${new Date(birthDate + 'T00:00:00').getDate()}`,
        birth_month: this.months[date.getMonth()],
        birth_year: date.getFullYear()
      };
    },

    zipcodeCheck() {
      // if (!this.formModel.mailingAddress.zipCode) return 'This is required'
      if (
        (this.formModel.mailingAddress.country == 'US' || this.formModel.mailingAddress.country == 'United States') &&
        !this.formModel.mailingAddress.zipCode
      ) {
        return 'This is required';
      } else {
        return true;
      }
    },

    handlePhoneValidation(payload) {
      // In Vue 3 version, payload structure is different
      const isValid = payload?.isValid || payload?.valid;
      const phoneNumber = this.formModel.phoneNumber;

      // Only show error if we have a number and it's invalid
      if (phoneNumber && phoneNumber.length > 0) {
        this.fields.phoneNumber.error = !isValid ? 'Please enter a valid phone number' : '';
      } else {
        this.fields.phoneNumber.error = '';
      }
    },

    handlePhoneInput() {
      // The @on-input event in Vue 3 version
      // Validation is handled by the @validate event
    },
    handleBlur() {
      this.phoneFieldTouched = true;
    },

    // eslint-disable-next-line no-unused-vars
    resultLookup(val) {
      setTimeout(() => {
        this.fields.googleAddress.listAvailable =
          document.getElementsByClassName('pac-item').length === 0 && (this.formModel.place || '').length > 1
            ? false
            : true;
      }, 500);
    },

    validateAge() {
      if (!this.dob.birth_year) return 'This is required';

      // Unparseable dates passed before this check existed; keep that.
      const age = ageInYears(this.formModel.birthDate);
      return age < MIN_LEARNER_AGE ? 'Age is too low' : true;
    },

    getMailingAddress(place) {
      let mailingAddress = {};
      let googleCountryName = '';
      let googleStateName = '';
      let googleCityName = '';
      let googleCountryCode = '';

      if ((place.addressComponents || []).length > 0) {
        place.addressComponents.forEach((elem) => {
          const types = elem.types;

          if (types.includes('street_number')) {
            mailingAddress.streetNumber = elem.longText;
          }
          if (types.includes('route')) {
            mailingAddress.route = elem.longText;
          }
          if (types.includes('locality')) {
            googleCityName = elem.longText;
          }
          if (types.includes('administrative_area_level_1')) {
            googleStateName = elem.longText;
          }
          if (types.includes('country')) {
            googleCountryName = elem.longText;
            googleCountryCode = elem.shortText;
          }
          if (types.includes('postal_code')) {
            mailingAddress.zipCode = elem.longText;
          }
        });

        // Match country from Google API to our country data
        // Google returns 2-char code (e.g., "TR"), we need to find the 3-char code (e.g., "TUR")
        if (googleCountryCode || googleCountryName) {
          const matchedCountry = this.countries.find(
            (c) => c.countryCodeTwoChar === googleCountryCode || c.description === googleCountryName
          );

          if (matchedCountry) {
            this.selectedCountryCode = matchedCountry.countryCode; // Use 3-char code
            this.stateOptions = this.getStateOptions(matchedCountry.countryCode);
            mailingAddress.country = matchedCountry.description;
          } else {
            // ULC-3059: when the codeset has no match (incl. the race where it has not
            // loaded yet), fall back to Google's locale-independent ISO code, never the
            // localized display name (e.g. 美国) which would be stored verbatim.
            mailingAddress.country = googleCountryCode || googleCountryName;
            this.stateOptions = [];
          }
        }

        // Match state from Google API to our state data - use state code
        // Priority: admin_area_level_1 > locality (for city-states like Istanbul)
        let matchedState = null;

        if (this.stateOptions.length > 0) {
          // First try to match administrative_area_level_1
          if (googleStateName) {
            matchedState = this.stateOptions.find(
              (s) => s.title.toLowerCase() === googleStateName.toLowerCase() || s.value === googleStateName
            );
          }

          // If no match and we have a city, check if city matches a state (e.g., Istanbul)
          if (!matchedState && googleCityName) {
            matchedState = this.stateOptions.find((s) => s.title.toLowerCase() === googleCityName.toLowerCase());
          }

          // Set state to the state code
          if (matchedState) {
            mailingAddress.state = matchedState.value;
          }
        }

        // Set city - but not if it matched a state
        if (googleCityName && (!matchedState || matchedState.title.toLowerCase() !== googleCityName.toLowerCase())) {
          mailingAddress.city = googleCityName;
        }

        // Combine street number and route for full street address
        mailingAddress.street = `${mailingAddress.streetNumber ? mailingAddress.streetNumber + ' ' : ''}${mailingAddress.route ? mailingAddress.route : ''}`;

        return mailingAddress;
      }
    },
    toggleNotificationEmail(value) {
      const action = value ? 'click' : 'unclick';
      this.asuoDataLayerClick('editProfileModal', '7', {
        action: action,
        text: this.formModel.email
      });
      // This will be triggered on checkbox click
      // You can perform any other actions you need here
    },

    updateGraduationMonth(updatedMonth) {
      this.asuoDataLayerClick('editProfileModal', '15', {
        section: 'high school ^ expected graduate date-month',
        text: updatedMonth
      });
      this.formModel = { ...this.formModel, highSchoolExpectedGraduationMonth: updatedMonth };
    },
    updateGraduationYear(updatedYear) {
      this.asuoDataLayerClick('editProfileModal', '15', {
        section: 'high school ^ expected graduate date-year',
        text: updatedYear
      });
      this.formModel = { ...this.formModel, highSchoolExpectedGraduationYear: updatedYear };
    }
  },

  async mounted() {
    await this.fetchCountryData();

    // Initialize state options for current country
    if (this.formModel.mailingAddress.country) {
      const matchedCountry = this.countryOptions.find((c) => c.title === this.formModel.mailingAddress.country);
      if (matchedCountry) {
        this.selectedCountryCode = matchedCountry.value;
        this.stateOptions = this.getStateOptions(matchedCountry.value);
      }
    }

    this.$nextTick(() => {
      this.initializeAutocomplete();
    });
  },

  created() {
    for (var i = new Date().getFullYear() - MIN_LEARNER_AGE; i >= 1900; i--) this.years.push(i);
    this.assignLearnerInfo();

    this.showNotificationEmail = !this.formModel.notificationsEmail;
  }
});
</script>
